import { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { SignOut } from "@/components/SignOut";
import { useBrand, BrandLogo, PoweredBy, brandName } from "@/components/Brand";
import { BusinessSwitcher } from "@/components/BusinessSwitcher";
import { api } from "@/lib/api";
import { applyPalette, PALETTE_VARS } from "@/lib/brand";

const tabs = [
  ["Overview", "/admin", true], ["Schedule", "/admin/schedule"], ["Client Profiles", "/admin/clients"],
  ["Reports", "/admin/reports"], ["Messages", "/admin/messages"], ["Library", "/admin/library"], ["Programs", "/admin/programs"], ["Payments", "/admin/payments"], ["Automations", "/admin/automations"], ["Platform Tour", "/admin/tour"], ["Settings", "/admin/settings"],
];

export default function AdminLayout() {
  const { pathname } = useLocation();
  const fetched = useBrand();
  const [brand, setBrand] = useState(null);
  const [unread, setUnread] = useState(0);
  useEffect(() => { setBrand(fetched); }, [fetched]);
  useEffect(() => {
    const root = document.documentElement.style;
    PALETTE_VARS.forEach((v) => root.removeProperty(v));
    const vars = applyPalette({ "--bg": "#0a0a0a", "--surface": "#141414", "--ink": "#ffffff", "--ink2": "#a3a3a3", "--accent": "#c8ff00", "--on-accent": "#0a0a0a" }, brand?.palette);
    if (brand?.palette) Object.entries(vars).forEach(([k, v]) => root.setProperty(k, v));
    return () => PALETTE_VARS.forEach((v) => root.removeProperty(v));
  }, [brand?.palette]);
  useEffect(() => {
    const refresh = () => api.get("/conversations/unread").then((r) => setUnread(r.data.totalUnread || 0)).catch(() => {});
    refresh();
    const warm = setTimeout(refresh, 1500);
    const t = setInterval(refresh, 30000);
    window.addEventListener("unread-changed", refresh);
    window.addEventListener("focus", refresh);
    return () => { clearTimeout(warm); clearInterval(t); window.removeEventListener("unread-changed", refresh); window.removeEventListener("focus", refresh); };
  }, [pathname]);
  useEffect(() => {
    const refresh = () => fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/brand`).then((r) => r.json()).then(setBrand).catch(() => {});
    const previewPalette = (e) => setBrand((b) => ({ ...(b || {}), palette: e.detail }));
    window.addEventListener("brand-changed", refresh);
    window.addEventListener("brand-preview", previewPalette);
    return () => { window.removeEventListener("brand-changed", refresh); window.removeEventListener("brand-preview", previewPalette); };
  }, []);
  return (
    <>
      <div className="topbar">
        <div className="brand">
          <BrandLogo brand={brand} size={34} testId="admin-brand-logo" />
          <BusinessSwitcher name={brand ? brandName(brand) : ""} />
        </div>
        <SignOut />
      </div>
      <nav className="nav" data-testid="admin-nav">
        {tabs.map(([label, href, end]) => (
          <NavLink key={href} to={href} end={!!end} className={({ isActive }) => (isActive ? "on" : "")}
            data-testid={`nav-${label.toLowerCase().replace(" ", "-")}`}>{label}{label === "Messages" && unread > 0 && <span className="nav-badge num" data-testid="nav-unread-badge">{unread}</span>}</NavLink>
        ))}
      </nav>
      <div className="wrap wide"><Outlet /></div>
      <PoweredBy />
    </>
  );
}
